const CEDORA_OPTION_PARAM = "cedora_option";
const CEDORA_PRODUCT_PARAM = "cedora_product";
const CEDORA_MATERIAL_PARAM = "cedora_material";
const CEDORA_COLOR_PARAM = "cedora_color";
const CEDORA_SEATER_PARAM = "cedora_seater";
const CEDORA_BED_SIZE_PARAM = "cedora_bed_size";
const CEDORA_ALL_SEATER_VALUES = ["4", "6", "8"];
const CEDORA_ALL_BED_SIZE_VALUES = ["double", "queen", "king"];
const CEDORA_DINING_TABLE_PARENT_SELECTOR =
  '[data-cedora-dining-table-parent], input[type="checkbox"][value="Dining Table"]';
const CEDORA_BED_FRAMES_PARENT_SELECTOR =
  '[data-cedora-bed-frames-parent], input[type="checkbox"][value="Bed Frames"]';
const CEDORA_CUSTOM_PARAMS = [
  CEDORA_OPTION_PARAM,
  CEDORA_PRODUCT_PARAM,
  CEDORA_MATERIAL_PARAM,
  CEDORA_COLOR_PARAM,
  CEDORA_SEATER_PARAM,
  CEDORA_BED_SIZE_PARAM,
];
const CEDORA_CUSTOM_CHECKBOX_SELECTOR =
  '[name="cedora_option"]:checked, [name="cedora_product"]:checked, [name="cedora_material"]:checked, [name="cedora_color"]:checked, [name="cedora_seater"]:checked, [name="cedora_bed_size"]:checked';
const CEDORA_CUSTOM_PILL_SELECTOR =
  "[data-cedora-option-active], [data-cedora-product-active], [data-cedora-material-active], [data-cedora-color-active], [data-cedora-seater-active], [data-cedora-bed-size-active]";
const CEDORA_NATIVE_PILL_SELECTOR =
  "#FacetFiltersActive .facet-remove:not([data-cedora-option-active]):not([data-cedora-product-active]):not([data-cedora-material-active]):not([data-cedora-color-active]):not([data-cedora-seater-active]):not([data-cedora-bed-size-active]):not(.facet-clear-all)";

const CedoraOptionsFilter = {
  getDiningTableCheckboxes(scope = document) {
    return Array.from(
      scope.querySelectorAll(CEDORA_DINING_TABLE_PARENT_SELECTOR)
    ).filter((checkbox) => this.isDiningTableCheckbox(checkbox));
  },

  isDiningTableCheckbox(checkbox) {
    if (!checkbox || checkbox.type !== "checkbox") return false;
    if (checkbox.hasAttribute("data-cedora-dining-table-parent")) return true;

    const value = (checkbox.value || "").trim().toLowerCase();
    if (value === "dining table") return true;

    const label = checkbox
      .closest("li")
      ?.querySelector(".reversed-link__text");
    return label?.textContent?.trim().toLowerCase() === "dining table" ||
      label?.textContent?.trim().toLowerCase() === "dining tables";
  },

  isDiningTableChecked(scope = document) {
    return this.getDiningTableCheckboxes(scope).some(
      (checkbox) => checkbox.checked
    );
  },

  setAllSeaterCheckboxes(checked, scope = document) {
    scope.querySelectorAll(`[name="${CEDORA_SEATER_PARAM}"]`).forEach((checkbox) => {
      checkbox.checked = checked;
    });
  },

  setSeaterCheckboxValue(value, checked, scope = document) {
    scope
      .querySelectorAll(`[name="${CEDORA_SEATER_PARAM}"][value="${value}"]`)
      .forEach((checkbox) => {
        checkbox.checked = checked;
      });
  },

  setDiningTableCheckboxes(checked, scope = document) {
    this.getDiningTableCheckboxes(scope).forEach((checkbox) => {
      checkbox.checked = checked;
    });
  },

  areAllSeatersSelected(selectedSeaters) {
    return CEDORA_ALL_SEATER_VALUES.every((value) =>
      selectedSeaters.includes(value)
    );
  },

  getCheckedSeaterValues(scope = document) {
    return [
      ...new Set(
        Array.from(
          scope.querySelectorAll(`[name="${CEDORA_SEATER_PARAM}"]:checked`)
        ).map((checkbox) => checkbox.value)
      ),
    ];
  },

  syncDiningTableSeaterTree(target, scope = document) {
    if (this.isDiningTableCheckbox(target)) {
      const checked = target.checked;
      this.setDiningTableCheckboxes(checked, document);
      this.setAllSeaterCheckboxes(checked, document);
      return { forceShopifySubmit: true, proxyTarget: target };
    }

    if (target?.name !== CEDORA_SEATER_PARAM) return null;

    this.setSeaterCheckboxValue(target.value, target.checked, document);

    const checkedSeaters = this.getCheckedSeaterValues(document);
    const parentChecked = this.isDiningTableChecked(document);

    if (checkedSeaters.length > 0 && !parentChecked) {
      this.setDiningTableCheckboxes(true, document);
      const parent = this.getDiningTableCheckboxes(document)[0] || target;
      return { forceShopifySubmit: true, proxyTarget: parent };
    }

    if (checkedSeaters.length === 0 && parentChecked) {
      this.setDiningTableCheckboxes(false, document);
      const parent = this.getDiningTableCheckboxes(document)[0] || target;
      return { forceShopifySubmit: true, proxyTarget: parent };
    }

    return { forceShopifySubmit: false };
  },

  getBedFramesCheckboxes(scope = document) {
    return Array.from(
      scope.querySelectorAll(CEDORA_BED_FRAMES_PARENT_SELECTOR)
    ).filter((checkbox) => this.isBedFramesCheckbox(checkbox));
  },

  isBedFramesCheckbox(checkbox) {
    if (!checkbox || checkbox.type !== "checkbox") return false;
    if (checkbox.hasAttribute("data-cedora-bed-frames-parent")) return true;

    const value = (checkbox.value || "").trim().toLowerCase();
    if (value === "bed frames") return true;

    const label = checkbox
      .closest("li")
      ?.querySelector(".reversed-link__text");
    return label?.textContent?.trim().toLowerCase() === "bed frames";
  },

  isBedFramesChecked(scope = document) {
    return this.getBedFramesCheckboxes(scope).some(
      (checkbox) => checkbox.checked
    );
  },

  setAllBedSizeCheckboxes(checked, scope = document) {
    scope.querySelectorAll(`[name="${CEDORA_BED_SIZE_PARAM}"]`).forEach((checkbox) => {
      checkbox.checked = checked;
    });
  },

  setBedSizeCheckboxValue(value, checked, scope = document) {
    scope
      .querySelectorAll(`[name="${CEDORA_BED_SIZE_PARAM}"][value="${value}"]`)
      .forEach((checkbox) => {
        checkbox.checked = checked;
      });
  },

  setBedFramesCheckboxes(checked, scope = document) {
    this.getBedFramesCheckboxes(scope).forEach((checkbox) => {
      checkbox.checked = checked;
    });
  },

  areAllBedSizesSelected(selectedBedSizes) {
    return CEDORA_ALL_BED_SIZE_VALUES.every((value) =>
      selectedBedSizes.includes(value)
    );
  },

  getCheckedBedSizeValues(scope = document) {
    return [
      ...new Set(
        Array.from(
          scope.querySelectorAll(`[name="${CEDORA_BED_SIZE_PARAM}"]:checked`)
        ).map((checkbox) => checkbox.value)
      ),
    ];
  },

  syncBedFramesSizeTree(target, scope = document) {
    if (this.isBedFramesCheckbox(target)) {
      const checked = target.checked;
      this.setBedFramesCheckboxes(checked, document);
      this.setAllBedSizeCheckboxes(checked, document);
      return { forceShopifySubmit: true, proxyTarget: target };
    }

    if (target?.name !== CEDORA_BED_SIZE_PARAM) return null;

    this.setBedSizeCheckboxValue(target.value, target.checked, document);

    const checkedBedSizes = this.getCheckedBedSizeValues(document);
    const parentChecked = this.isBedFramesChecked(document);

    if (checkedBedSizes.length > 0 && !parentChecked) {
      this.setBedFramesCheckboxes(true, document);
      const parent = this.getBedFramesCheckboxes(document)[0] || target;
      return { forceShopifySubmit: true, proxyTarget: parent };
    }

    if (checkedBedSizes.length === 0 && parentChecked) {
      this.setBedFramesCheckboxes(false, document);
      const parent = this.getBedFramesCheckboxes(document)[0] || target;
      return { forceShopifySubmit: true, proxyTarget: parent };
    }

    return { forceShopifySubmit: false };
  },

  syncCategoryChildTrees(target, scope = document) {
    return (
      this.syncDiningTableSeaterTree(target, scope) ||
      this.syncBedFramesSizeTree(target, scope)
    );
  },

  getSelectedOptions(url = window.location.href) {
    const values = new URL(url, window.location.origin).searchParams.getAll(
      CEDORA_OPTION_PARAM
    );
    return [...new Set(values)];
  },

  getSelectedProducts(url = window.location.href) {
    const values = new URL(url, window.location.origin).searchParams.getAll(
      CEDORA_PRODUCT_PARAM
    );
    return [...new Set(values)];
  },

  getSelectedMaterials(url = window.location.href) {
    const values = new URL(url, window.location.origin).searchParams.getAll(
      CEDORA_MATERIAL_PARAM
    );
    return [...new Set(values)];
  },

  getSelectedColors(url = window.location.href) {
    const values = new URL(url, window.location.origin).searchParams.getAll(
      CEDORA_COLOR_PARAM
    );
    return [...new Set(values)];
  },

  getSelectedSeaters(url = window.location.href) {
    const values = new URL(url, window.location.origin).searchParams.getAll(
      CEDORA_SEATER_PARAM
    );
    return [...new Set(values)];
  },

  syncCheckboxesFromUrl(url = window.location.href) {
    const selectedOptions = this.getSelectedOptions(url);
    document.querySelectorAll('[name="cedora_option"]').forEach((checkbox) => {
      checkbox.checked = selectedOptions.includes(checkbox.value);
    });

    const selectedProducts = this.getSelectedProducts(url);
    document.querySelectorAll('[name="cedora_product"]').forEach((checkbox) => {
      checkbox.checked = selectedProducts.includes(checkbox.value);
    });

    const selectedMaterials = this.getSelectedMaterials(url);
    document.querySelectorAll('[name="cedora_material"]').forEach((checkbox) => {
      checkbox.checked = selectedMaterials.includes(checkbox.value);
    });

    const selectedColors = this.getSelectedColors(url);
    document.querySelectorAll('[name="cedora_color"]').forEach((checkbox) => {
      checkbox.checked = selectedColors.includes(checkbox.value);
    });

    const selectedSeaters = this.getSelectedSeaters(url);
    const diningTableChecked = this.isDiningTableChecked();
    document.querySelectorAll(`[name="${CEDORA_SEATER_PARAM}"]`).forEach((checkbox) => {
      if (!diningTableChecked) {
        checkbox.checked = false;
      } else if (selectedSeaters.length > 0) {
        checkbox.checked = selectedSeaters.includes(checkbox.value);
      } else {
        checkbox.checked = true;
      }
    });

    const selectedBedSizes = this.getSelectedBedSizes(url);
    const bedFramesChecked = this.isBedFramesChecked();
    document.querySelectorAll(`[name="${CEDORA_BED_SIZE_PARAM}"]`).forEach((checkbox) => {
      if (!bedFramesChecked) {
        checkbox.checked = false;
      } else if (selectedBedSizes.length > 0) {
        checkbox.checked = selectedBedSizes.includes(checkbox.value);
      } else {
        checkbox.checked = true;
      }
    });
  },

  getSelectedBedSizes(url = window.location.href) {
    const values = new URL(url, window.location.origin).searchParams.getAll(
      CEDORA_BED_SIZE_PARAM
    );
    return [...new Set(values)];
  },

  appendCustomParamsToUrl(url, form = null) {
    CEDORA_CUSTOM_PARAMS.forEach((param) => {
      url.searchParams.delete(param);
    });

    const scope = form || document;
    const selectedValues = {
      [CEDORA_OPTION_PARAM]: new Set(),
      [CEDORA_PRODUCT_PARAM]: new Set(),
      [CEDORA_MATERIAL_PARAM]: new Set(),
      [CEDORA_COLOR_PARAM]: new Set(),
      [CEDORA_SEATER_PARAM]: new Set(),
      [CEDORA_BED_SIZE_PARAM]: new Set(),
    };

    scope.querySelectorAll(CEDORA_CUSTOM_CHECKBOX_SELECTOR).forEach((checkbox) => {
      selectedValues[checkbox.name]?.add(checkbox.value);
    });

    CEDORA_CUSTOM_PARAMS.forEach((param) => {
      if (param === CEDORA_SEATER_PARAM) {
        const seaterValues = [...selectedValues[param]];
        if (
          seaterValues.length === 0 ||
          this.areAllSeatersSelected(seaterValues)
        ) {
          return;
        }
      }

      if (param === CEDORA_BED_SIZE_PARAM) {
        const bedSizeValues = [...selectedValues[param]];
        if (
          bedSizeValues.length === 0 ||
          this.areAllBedSizesSelected(bedSizeValues)
        ) {
          return;
        }
      }

      selectedValues[param].forEach((value) => {
        url.searchParams.append(param, value);
      });
    });

    return url;
  },

  appendToUrl(url, form = null) {
    return this.appendCustomParamsToUrl(url, form);
  },

  createCloseIcon() {
    const icon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    icon.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    icon.setAttribute("aria-hidden", "true");
    icon.setAttribute("focusable", "false");
    icon.setAttribute("class", "icon icon-close icon--extra-small icon--thick");
    icon.setAttribute("fill", "none");
    icon.setAttribute("viewBox", "0 0 24 24");

    const pathOne = document.createElementNS("http://www.w3.org/2000/svg", "path");
    pathOne.setAttribute("d", "M18.75 5.13496L5.25 18.8544");
    pathOne.setAttribute("stroke", "currentColor");
    pathOne.setAttribute("stroke-width", "1.5");
    pathOne.setAttribute("stroke-linecap", "round");
    pathOne.setAttribute("stroke-linejoin", "round");

    const pathTwo = document.createElementNS("http://www.w3.org/2000/svg", "path");
    pathTwo.setAttribute("d", "M18.75 18.8544L5.25 5.13496");
    pathTwo.setAttribute("stroke", "currentColor");
    pathTwo.setAttribute("stroke-width", "1.5");
    pathTwo.setAttribute("stroke-linecap", "round");
    pathTwo.setAttribute("stroke-linejoin", "round");

    icon.append(pathOne, pathTwo);
    return icon;
  },

  getCustomFilterLabel(param, value) {
    const checkbox = document.querySelector(
      `[name="${param}"][value="${value}"]`
    );
    const label = checkbox?.closest("li")?.querySelector(".reversed-link__text");
    return label?.textContent?.trim() || value;
  },

  getOptionLabel(option) {
    return this.getCustomFilterLabel(CEDORA_OPTION_PARAM, option);
  },

  getCurrentCustomSelections() {
    return {
      selectedOptions: this.getSelectedOptions(),
      selectedProducts: this.getSelectedProducts(),
      selectedMaterials: this.getSelectedMaterials(),
      selectedColors: this.getSelectedColors(),
      selectedSeaters: this.getSelectedSeaters(),
      selectedBedSizes: this.getSelectedBedSizes(),
    };
  },

  hasPartialSeaterFilter(selectedSeaters) {
    return (
      selectedSeaters.length > 0 &&
      !this.areAllSeatersSelected(selectedSeaters)
    );
  },

  hasPartialBedSizeFilter(selectedBedSizes) {
    return (
      selectedBedSizes.length > 0 &&
      !this.areAllBedSizesSelected(selectedBedSizes)
    );
  },

  hasActiveCustomFilters(
    selectedOptions,
    selectedProducts,
    selectedMaterials,
    selectedColors,
    selectedSeaters,
    selectedBedSizes = []
  ) {
    return (
      selectedOptions.length > 0 ||
      selectedProducts.length > 0 ||
      selectedMaterials.length > 0 ||
      selectedColors.length > 0 ||
      this.hasPartialSeaterFilter(selectedSeaters) ||
      this.hasPartialBedSizeFilter(selectedBedSizes)
    );
  },

  getProductKey(column) {
    const productId = column.dataset.productId;
    if (productId) return productId;

    const productLink = column.querySelector('a[href*="/products/"]');
    return productLink?.getAttribute("href") || column.innerHTML;
  },

  getAllProductsCacheKey() {
    const url = new URL(window.location.href);
    CEDORA_CUSTOM_PARAMS.forEach((param) => url.searchParams.delete(param));
    url.searchParams.delete("page");
    url.searchParams.delete("section_id");
    return url.toString();
  },

  hasAllProductsCache() {
    return this.allProductsCache?.key === this.getAllProductsCacheKey();
  },

  getSectionId() {
    const form = document.querySelector('form[is="facet-form"]');
    return form ? FoxTheme.utils.getSectionId(form) : null;
  },

  getNextPageUrl(source = document) {
    const nextButton = source.querySelector(
      "#ProductGridContainer .pagination button[is='load-more-button'][action]"
    );
    if (!nextButton) return null;

    const url = new URL(nextButton.getAttribute("action"), window.location.origin);
    CEDORA_CUSTOM_PARAMS.forEach((param) => url.searchParams.delete(param));
    const sectionId = this.getSectionId();
    if (sectionId) url.searchParams.set("section_id", sectionId);
    return url.toString();
  },

  collectCurrentProductColumns() {
    return Array.from(
      document.querySelectorAll("#ProductsList .product-column[data-product-option]")
    ).map((column) => column.cloneNode(true));
  },

  async getAllProductColumns() {
    const cacheKey = this.getAllProductsCacheKey();
    if (this.allProductsCache?.key === cacheKey) {
      return this.allProductsCache.columns;
    }

    if (this.allProductsPromise?.key === cacheKey) {
      return this.allProductsPromise.promise;
    }

    const promise = this.fetchAllProductColumns();
    this.allProductsPromise = { key: cacheKey, promise };

    const columns = await promise;
    this.allProductsCache = { key: cacheKey, columns };
    this.allProductsPromise = null;
    return columns;
  },

  async fetchAllProductColumns() {
    const columns = this.collectCurrentProductColumns();
    const seenKeys = new Set(columns.map((column) => this.getProductKey(column)));
    let nextUrl = this.getNextPageUrl();

    while (nextUrl) {
      const responseText = await fetch(nextUrl).then((response) => response.text());
      const parsedHTML = new DOMParser().parseFromString(responseText, "text/html");
      const nextColumns = parsedHTML.querySelectorAll(
        "#ProductsList .product-column[data-product-option]"
      );

      nextColumns.forEach((column) => {
        const productKey = this.getProductKey(column);
        if (seenKeys.has(productKey)) return;

        seenKeys.add(productKey);
        columns.push(column.cloneNode(true));
      });

      nextUrl = this.getNextPageUrl(parsedHTML);
    }

    return columns;
  },

  appendMissingProductColumns(columns) {
    const productList = document.getElementById("ProductsList");
    if (!productList) return;

    const existingKeys = new Set(
      Array.from(
        productList.querySelectorAll(".product-column[data-product-option]")
      ).map((column) => this.getProductKey(column))
    );

    columns.forEach((column) => {
      const productKey = this.getProductKey(column);
      if (existingKeys.has(productKey)) return;

      existingKeys.add(productKey);
      productList.appendChild(column.cloneNode(true));
    });

    const gridList = document.querySelector("grid-list");
    gridList && gridList.reload();
  },

  removePagination() {
    document.querySelector("#ProductGridContainer .pagination")?.remove();
  },

  updateCustomFilterCounts(columns) {
    const counts = {
      options: {
        in_stock: 0,
        pre_order: 0,
        on_sale: 0,
        clearance: 0,
      },
      products: {
        bedroom_sets: 0,
        dining_room_sets: 0,
        living_room_sets: 0,
        bundle: 0,
      },
      materials: {
        pine: 0,
        acacia: 0,
        oak: 0,
      },
      colors: {
        black: 0,
        white: 0,
        other: 0,
      },
      seaters: {
        4: 0,
        6: 0,
        8: 0,
      },
      bedSizes: {
        double: 0,
        queen: 0,
        king: 0,
      },
    };

    columns.forEach((column) => {
      if (column.dataset.productOption === "in-stock") {
        counts.options.in_stock += 1;
      }
      if (column.dataset.productOption === "pre-order") {
        counts.options.pre_order += 1;
      }
      if (column.dataset.productOnSale === "true") {
        counts.options.on_sale += 1;
      }
      if (column.dataset.productClearance === "true") {
        counts.options.clearance += 1;
      }
      const setKind = column.dataset.productSetOf || "";
      if (
        setKind === "bedroom_sets" ||
        setKind === "dining_room_sets" ||
        setKind === "living_room_sets"
      ) {
        counts.products[setKind] += 1;
      }
      if (column.dataset.productBundle === "true") {
        counts.products.bundle += 1;
      }

      const materialText = column.dataset.productMaterial || "";
      Object.keys(counts.materials).forEach((material) => {
        if (materialText.includes(material)) {
          counts.materials[material] += 1;
        }
      });

      const colorText = column.dataset.productColor || "";
      Object.keys(counts.colors).forEach((color) => {
        if (colorText.includes(color)) {
          counts.colors[color] += 1;
        }
      });

      const seaterTokens = (column.dataset.productSeaters || "")
        .trim()
        .split(/\s+/)
        .filter(Boolean);
      Object.keys(counts.seaters).forEach((seater) => {
        if (seaterTokens.includes(seater)) {
          counts.seaters[seater] += 1;
        }
      });

      const bedSizeTokens = (column.dataset.productBedSizes || "")
        .trim()
        .split(/\s+/)
        .filter(Boolean);
      Object.keys(counts.bedSizes).forEach((bedSize) => {
        if (bedSizeTokens.includes(bedSize)) {
          counts.bedSizes[bedSize] += 1;
        }
      });
    });

    this.updateCustomCountElements(CEDORA_OPTION_PARAM, counts.options);
    this.updateCustomCountElements(CEDORA_PRODUCT_PARAM, counts.products);
    this.updateCustomCountElements(CEDORA_MATERIAL_PARAM, counts.materials);
    this.updateCustomCountElements(CEDORA_COLOR_PARAM, counts.colors);
    this.updateCustomCountElements(CEDORA_SEATER_PARAM, counts.seaters);
    this.updateCustomCountElements(CEDORA_BED_SIZE_PARAM, counts.bedSizes);
    this.toggleSeaterFilterVisibility(counts.seaters);
    this.toggleBedSizeFilterVisibility(counts.bedSizes);
  },

  updateCustomCountElements(param, counts) {
    Object.entries(counts).forEach(([value, count]) => {
      document
        .querySelectorAll(`[name="${param}"][value="${value}"]`)
        .forEach((checkbox) => {
          checkbox.dataset.cedoraCustomCount = count;
          const countElement = checkbox
            .closest("li")
            ?.querySelector(".count");
          if (countElement) countElement.textContent = count;
        });
    });
  },

  toggleSeaterFilterVisibility(seaterCounts) {
    const total = Object.values(seaterCounts).reduce(
      (sum, count) => sum + count,
      0
    );
    document.querySelectorAll(".facet-seaters").forEach((element) => {
      element.hidden = total === 0;
    });
  },

  toggleBedSizeFilterVisibility(bedSizeCounts) {
    const total = Object.values(bedSizeCounts).reduce(
      (sum, count) => sum + count,
      0
    );
    document.querySelectorAll(".facet-bed-sizes").forEach((element) => {
      element.hidden = total === 0;
    });
  },

  createCountLoadingIcon() {
    const wrapper = document.createElement("span");
    wrapper.className = "loading__spinner";
    wrapper.style.display = "inline-flex";
    wrapper.style.alignItems = "center";
    wrapper.style.justifyContent = "center";
    wrapper.style.width = "1em";
    wrapper.innerHTML = `
      <svg aria-hidden="true" focusable="false" class="spinner icon icon--small" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
        <circle class="path" fill="none" stroke-width="4" cx="33" cy="33" r="30"></circle>
      </svg>
    `;
    return wrapper;
  },

  setCustomFilterCountsLoading() {
    document
      .querySelectorAll(
        ".facet-product .count, .facet-material .count, .facet-options .count, .facet-color .count, .facet-seaters .count, .facet-bed-sizes .count"
      )
      .forEach((countElement) => {
        countElement.replaceChildren(this.createCountLoadingIcon());
      });
  },

  async refreshCustomFilterCounts() {
    if (!this.hasAllProductsCache()) {
      this.setCustomFilterCountsLoading();
    }

    const columns = await this.getAllProductColumns();
    this.updateCustomFilterCounts(columns);
  },

  removeCustomFilter(param, valueToRemove) {
    const url = new URL(window.location.href);
    const remainingValues = new URL(url, window.location.origin)
      .searchParams.getAll(param)
      .filter((value) => value !== valueToRemove);

    url.searchParams.delete(param);
    [...new Set(remainingValues)].forEach((value) => {
      url.searchParams.append(param, value);
    });
    url.searchParams.delete("page");

    history.replaceState({}, "", url.toString());
    this.syncCheckboxesFromUrl(url.toString());
    this.apply();
  },

  removeOption(optionToRemove) {
    this.removeCustomFilter(CEDORA_OPTION_PARAM, optionToRemove);
  },

  removeProduct(valueToRemove) {
    this.removeCustomFilter(CEDORA_PRODUCT_PARAM, valueToRemove);
  },

  removeMaterial(valueToRemove) {
    this.removeCustomFilter(CEDORA_MATERIAL_PARAM, valueToRemove);
  },

  removeColor(valueToRemove) {
    this.removeCustomFilter(CEDORA_COLOR_PARAM, valueToRemove);
  },

  removeSeater(valueToRemove) {
    this.removeCustomFilter(CEDORA_SEATER_PARAM, valueToRemove);
  },

  removeBedSize(valueToRemove) {
    this.removeCustomFilter(CEDORA_BED_SIZE_PARAM, valueToRemove);
  },

  updateFacetCount() {
    const seaterCount = this.hasPartialSeaterFilter(this.getSelectedSeaters())
      ? this.getSelectedSeaters().length
      : 0;
    const bedSizeCount = this.hasPartialBedSizeFilter(this.getSelectedBedSizes())
      ? this.getSelectedBedSizes().length
      : 0;
    const customCount =
      this.getSelectedOptions().length +
      this.getSelectedProducts().length +
      this.getSelectedMaterials().length +
      this.getSelectedColors().length +
      seaterCount +
      bedSizeCount;
    const shopifyCount = document.querySelectorAll(
      CEDORA_NATIVE_PILL_SELECTOR
    ).length;
    const totalCount = shopifyCount + customCount;

    document.querySelectorAll("facet-count").forEach((element) => {
      element.textContent = `(${totalCount})`;
      element.hidden = totalCount === 0;
    });
  },

  init() {
    if (this.initialized) return;
    this.initialized = true;

    document.addEventListener("click", (event) => {
      const optionPill = event.target.closest("[data-cedora-option-active]");
      if (optionPill) {
        event.preventDefault();
        this.removeOption(optionPill.dataset.cedoraOptionActive);
        return;
      }

      const productPill = event.target.closest("[data-cedora-product-active]");
      if (productPill) {
        event.preventDefault();
        this.removeProduct(productPill.dataset.cedoraProductActive);
        return;
      }

      const materialPill = event.target.closest("[data-cedora-material-active]");
      if (materialPill) {
        event.preventDefault();
        this.removeMaterial(materialPill.dataset.cedoraMaterialActive);
        return;
      }

      const colorPill = event.target.closest("[data-cedora-color-active]");
      if (colorPill) {
        event.preventDefault();
        this.removeColor(colorPill.dataset.cedoraColorActive);
        return;
      }

      const seaterPill = event.target.closest("[data-cedora-seater-active]");
      if (seaterPill) {
        event.preventDefault();
        this.removeSeater(seaterPill.dataset.cedoraSeaterActive);
        return;
      }

      const bedSizePill = event.target.closest("[data-cedora-bed-size-active]");
      if (bedSizePill) {
        event.preventDefault();
        this.removeBedSize(bedSizePill.dataset.cedoraBedSizeActive);
      }
    });
  },

  isProductVisible(
    column,
    selectedOptions,
    selectedProducts,
    selectedMaterials,
    selectedColors,
    selectedSeaters,
    selectedBedSizes = []
  ) {
    const showInStock = selectedOptions.includes("in_stock");
    const showPreOrder = selectedOptions.includes("pre_order");
    const showOnSale = selectedOptions.includes("on_sale");
    const showClearance = selectedOptions.includes("clearance");

    let passesStockFilter = true;
    if (showInStock || showPreOrder) {
      if (showInStock && showPreOrder) {
        passesStockFilter = true;
      } else if (showInStock) {
        passesStockFilter = column.dataset.productOption === "in-stock";
      } else {
        passesStockFilter = column.dataset.productOption === "pre-order";
      }
    }

    let passesSaleFilter = true;
    if (showOnSale) {
      passesSaleFilter = column.dataset.productOnSale === "true";
    }

    let passesClearanceFilter = true;
    if (showClearance) {
      passesClearanceFilter = column.dataset.productClearance === "true";
    }

    const selectedSetKinds = selectedProducts.filter(
      (value) => value !== "bundle"
    );
    const showBundle = selectedProducts.includes("bundle");

    let passesProductFilter = true;
    if (selectedSetKinds.length > 0 || showBundle) {
      const matchesSetKind = selectedSetKinds.includes(
        column.dataset.productSetOf || ""
      );
      const matchesBundle = showBundle && column.dataset.productBundle === "true";
      passesProductFilter = matchesSetKind || matchesBundle;
    }

    let passesMaterialFilter = true;
    if (selectedMaterials.length > 0) {
      const materialText = column.dataset.productMaterial || "";
      passesMaterialFilter = selectedMaterials.some((material) =>
        materialText.includes(material)
      );
    }

    let passesColorFilter = true;
    if (selectedColors.length > 0) {
      const colorText = column.dataset.productColor || "";
      passesColorFilter = selectedColors.some((color) =>
        colorText.includes(color)
      );
    }

    let passesSeaterFilter = true;
    if (this.hasPartialSeaterFilter(selectedSeaters)) {
      const seaterTokens = (column.dataset.productSeaters || "")
        .trim()
        .split(/\s+/)
        .filter(Boolean);
      passesSeaterFilter = selectedSeaters.some((seater) =>
        seaterTokens.includes(seater)
      );
    }

    let passesBedSizeFilter = true;
    if (this.hasPartialBedSizeFilter(selectedBedSizes)) {
      const bedSizeTokens = (column.dataset.productBedSizes || "")
        .trim()
        .split(/\s+/)
        .filter(Boolean);
      passesBedSizeFilter = selectedBedSizes.some((bedSize) =>
        bedSizeTokens.includes(bedSize)
      );
    }

    return (
      passesStockFilter &&
      passesSaleFilter &&
      passesClearanceFilter &&
      passesProductFilter &&
      passesMaterialFilter &&
      passesColorFilter &&
      passesSeaterFilter &&
      passesBedSizeFilter
    );
  },

  async apply() {
    const selectedOptions = this.getSelectedOptions();
    const selectedProducts = this.getSelectedProducts();
    const selectedMaterials = this.getSelectedMaterials();
    const selectedColors = this.getSelectedColors();
    const selectedSeaters = this.getSelectedSeaters();
    const selectedBedSizes = this.getSelectedBedSizes();
    const hasActiveCustomFilters = this.hasActiveCustomFilters(
      selectedOptions,
      selectedProducts,
      selectedMaterials,
      selectedColors,
      selectedSeaters,
      selectedBedSizes
    );

    if (hasActiveCustomFilters) {
      if (!this.hasAllProductsCache()) {
        this.setCustomFilterCountsLoading();
      }

      const columns = await this.getAllProductColumns();
      this.updateCustomFilterCounts(columns);
      this.appendMissingProductColumns(columns);
      this.removePagination();
    } else {
      this.refreshCustomFilterCounts();
    }

    const productColumns = document.querySelectorAll(
      "#ProductsList .product-column[data-product-option]"
    );
    let visibleCount = 0;

    productColumns.forEach((column) => {
      const visible = this.isProductVisible(
        column,
        selectedOptions,
        selectedProducts,
        selectedMaterials,
        selectedColors,
        selectedSeaters,
        selectedBedSizes
      );
      column.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    this.updateProductCount(
      visibleCount,
      productColumns.length,
      selectedOptions,
      selectedProducts,
      selectedMaterials,
      selectedColors,
      selectedSeaters,
      selectedBedSizes
    );
    this.updateActiveFacets(
      selectedOptions,
      selectedProducts,
      selectedMaterials,
      selectedColors,
      selectedSeaters,
      selectedBedSizes
    );
    this.updateFacetCount();
    return visibleCount;
  },

  updateProductCount(
    visibleCount,
    totalCount,
    selectedOptions,
    selectedProducts,
    selectedMaterials,
    selectedColors,
    selectedSeaters,
    selectedBedSizes = []
  ) {
    const productCountElement = document.getElementById("ProductCount");
    if (!productCountElement) return;

    const hasActiveFilters =
      selectedOptions.includes("in_stock") ||
      selectedOptions.includes("pre_order") ||
      selectedOptions.includes("on_sale") ||
      selectedOptions.includes("clearance") ||
      selectedProducts.length > 0 ||
      selectedMaterials.length > 0 ||
      selectedColors.length > 0 ||
      this.hasPartialSeaterFilter(selectedSeaters) ||
      this.hasPartialBedSizeFilter(selectedBedSizes);

    if (!hasActiveFilters) {
      if (productCountElement.dataset.baselineCount) {
        productCountElement.textContent =
          productCountElement.dataset.baselineCount;
        delete productCountElement.dataset.baselineCount;
      }
      return;
    }

    if (!productCountElement.dataset.baselineCount) {
      productCountElement.dataset.baselineCount =
        productCountElement.textContent;
    }

    if (totalCount === 0) return;

    const countLabel =
      visibleCount === 1
        ? `${visibleCount} product`
        : `${visibleCount} products`;

    productCountElement.textContent = countLabel;
  },

  updateActiveFacets(
    selectedOptions,
    selectedProducts,
    selectedMaterials,
    selectedColors,
    selectedSeaters,
    selectedBedSizes = []
  ) {
    const activeFacetsContainer = document.getElementById("FacetFiltersActive");
    if (!activeFacetsContainer) return;

    activeFacetsContainer
      .querySelectorAll(CEDORA_CUSTOM_PILL_SELECTOR)
      .forEach((element) => element.remove());

    selectedOptions.forEach((option) => {
      activeFacetsContainer.prepend(
        this.createActivePill({
          param: CEDORA_OPTION_PARAM,
          value: option,
          datasetKey: "cedoraOptionActive",
          datasetValue: option,
        })
      );
    });

    selectedProducts.forEach((productFilter) => {
      activeFacetsContainer.prepend(
        this.createActivePill({
          param: CEDORA_PRODUCT_PARAM,
          value: productFilter,
          datasetKey: "cedoraProductActive",
          datasetValue: productFilter,
        })
      );
    });

    selectedMaterials.forEach((material) => {
      activeFacetsContainer.prepend(
        this.createActivePill({
          param: CEDORA_MATERIAL_PARAM,
          value: material,
          datasetKey: "cedoraMaterialActive",
          datasetValue: material,
        })
      );
    });

    selectedColors.forEach((color) => {
      activeFacetsContainer.prepend(
        this.createActivePill({
          param: CEDORA_COLOR_PARAM,
          value: color,
          datasetKey: "cedoraColorActive",
          datasetValue: color,
        })
      );
    });

    if (this.hasPartialSeaterFilter(selectedSeaters)) {
      selectedSeaters.forEach((seater) => {
        activeFacetsContainer.prepend(
          this.createActivePill({
            param: CEDORA_SEATER_PARAM,
            value: seater,
            datasetKey: "cedoraSeaterActive",
            datasetValue: seater,
          })
        );
      });
    }

    if (this.hasPartialBedSizeFilter(selectedBedSizes)) {
      selectedBedSizes.forEach((bedSize) => {
        activeFacetsContainer.prepend(
          this.createActivePill({
            param: CEDORA_BED_SIZE_PARAM,
            value: bedSize,
            datasetKey: "cedoraBedSizeActive",
            datasetValue: bedSize,
          })
        );
      });
    }

    this.updateClearAllLink(
      activeFacetsContainer,
      selectedOptions,
      selectedProducts,
      selectedMaterials,
      selectedColors,
      selectedSeaters,
      selectedBedSizes
    );
  },

  createActivePill({ param, value, datasetKey, datasetValue }) {
    const pill = document.createElement("a");
    pill.className = "facet-remove btn btn--secondary flex relative";
    pill.href = "#";
    pill.dataset[datasetKey] = datasetValue;
    pill.setAttribute("role", "button");
    pill.setAttribute(
      "aria-label",
      `Clear ${this.getCustomFilterLabel(param, value)}`
    );

    const buttonText = document.createElement("div");
    buttonText.className =
      "btn__text flex items-center justify-between gap-2";

    const title = document.createElement("div");
    title.className =
      "facet-title text-wrap flex items-center gap-2 text-body-2";
    title.textContent = this.getCustomFilterLabel(param, value);

    buttonText.append(title, this.createCloseIcon());
    pill.appendChild(buttonText);
    return pill;
  },

  updateClearAllLink(
    activeFacetsContainer,
    selectedOptions,
    selectedProducts,
    selectedMaterials,
    selectedColors,
    selectedSeaters,
    selectedBedSizes = []
  ) {
    const shopifyCount = activeFacetsContainer.querySelectorAll(
      CEDORA_NATIVE_PILL_SELECTOR
    ).length;
    const seaterCount = this.hasPartialSeaterFilter(selectedSeaters)
      ? selectedSeaters.length
      : 0;
    const bedSizeCount = this.hasPartialBedSizeFilter(selectedBedSizes)
      ? selectedBedSizes.length
      : 0;
    const totalCount =
      shopifyCount +
      selectedOptions.length +
      selectedProducts.length +
      selectedMaterials.length +
      selectedColors.length +
      seaterCount +
      bedSizeCount;
    const clearAllLink = activeFacetsContainer.querySelector(".facet-clear-all");

    if (totalCount > 1 && !clearAllLink) {
      const form = document.querySelector('form[is="facet-form"]');
      if (!form) return;

      const link = document.createElement("a", { is: "facet-remove" });
      link.className = "facet-clear-all btn--link text-body-2";
      link.href = form.action;
      link.textContent =
        activeFacetsContainer.dataset.clearAllLabel || "Clear all";
      activeFacetsContainer.appendChild(link);
      return;
    }

    if (totalCount <= 1 && clearAllLink) {
      clearAllLink.remove();
    }
  },

  buildRemoveUrl(param, valueToRemove) {
    const url = new URL(window.location.href);
    const remainingValues = new URL(url, window.location.origin)
      .searchParams.getAll(param)
      .filter((value) => value !== valueToRemove);

    url.searchParams.delete(param);
    [...new Set(remainingValues)].forEach((value) => {
      url.searchParams.append(param, value);
    });
    url.searchParams.delete("page");

    return url.toString();
  },
};

class FacetShort extends HTMLSelectElement {
  constructor() {
    super();
    this.initMotionInView();
    this.addEventListener("change", this.onSelectChange.bind(this));
  }

  get options() {
    return this.getElementsByTagName("option");
  }

  get fakeSelectElement() {
    return this.previousElementSibling;
  }

  initMotionInView() {
    FoxTheme.Motion.inView(this, this.calcSelectWidth.bind(this), {
      margin: "200px 0px 200px 0px",
    });
  }

  calcSelectWidth() {
    const selectStyle = window.getComputedStyle(this);
    const selectedOptionText = this.options[this.selectedIndex].text;

    const textElement = this.createTextElement(selectedOptionText, selectStyle);
    document.body.appendChild(textElement);
    const selectWidth = textElement.offsetWidth;
    textElement.remove();

    this.style.setProperty("--width", `${selectWidth + 22}px`);
  }

  createTextElement(text, style) {
    const textElement = document.createElement("span");
    textElement.style.fontFamily = style.fontFamily;
    textElement.style.fontSize = style.fontSize;
    textElement.style.fontWeight = style.fontWeight;
    textElement.style.visibility = "hidden";
    textElement.style.position = "absolute";
    textElement.innerHTML = text;
    return textElement;
  }

  onSelectChange(event) {
    this.calcSelectWidth();
    this.updateFormParams(event);
  }

  updateFormParams(event) {
    const form = this.getClosestFacetForm() || this.getFirstFacetForm();

    if (form) {
      const url = new URL(window.location.href);
      url.searchParams.set("sort_by", event.target.value);
      url.searchParams.set("section_id", FoxTheme.utils.getSectionId(form));
      url.searchParams.delete("page");
      CedoraOptionsFilter.appendToUrl(url, form);
      form.renderSection(url.toString(), event);
    }
  }

  getClosestFacetForm() {
    return this.closest('form[is="facet-form"]');
  }

  getFirstFacetForm() {
    return document.querySelector('form[is="facet-form"]');
  }
}
customElements.define("facet-short", FacetShort, { extends: "select" });

class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.minRangeInput = this.querySelector('input[type="range"]:first-child');
    this.maxRangeInput = this.querySelector('input[type="range"]:last-child');
    this.minPriceInput = this.querySelector('input[name="filter.v.price.gte"]');
    this.maxPriceInput = this.querySelector('input[name="filter.v.price.lte"]');

    this.minPriceInput.addEventListener("focus", this.minPriceInput.select);
    this.maxPriceInput.addEventListener("focus", this.maxPriceInput.select);
    this.minPriceInput.addEventListener(
      "change",
      this.handleInputMinChange.bind(this)
    );
    this.maxPriceInput.addEventListener(
      "change",
      this.handleInputMaxChange.bind(this)
    );

    this.minRangeInput.addEventListener(
      "change",
      this.handleRangeMinChange.bind(this)
    );
    this.maxRangeInput.addEventListener(
      "change",
      this.handleRangeMaxChange.bind(this)
    );
    this.minRangeInput.addEventListener(
      "input",
      this.handleRangeMinInput.bind(this)
    );
    this.maxRangeInput.addEventListener(
      "input",
      this.handleRangeMaxInput.bind(this)
    );
  }

  handleInputMinChange(event) {
    event.preventDefault();
    event.target.value = Math.max(
      Math.min(
        parseInt(event.target.value),
        parseInt(this.maxPriceInput.value || event.target.max) - 1
      ),
      event.target.min
    );
    this.minRangeInput.value = event.target.value;
    this.minRangeInput.parentElement.style.setProperty(
      "--range-min",
      `${
        (parseInt(this.minRangeInput.value) /
          parseInt(this.minRangeInput.max)) *
        100
      }%`
    );
  }

  handleInputMaxChange(event) {
    event.preventDefault();
    event.target.value = Math.min(
      Math.max(
        parseInt(event.target.value),
        parseInt(this.minPriceInput.value || event.target.min) + 1
      ),
      event.target.max
    );
    this.maxRangeInput.value = event.target.value;
    this.maxRangeInput.parentElement.style.setProperty(
      "--range-max",
      `${
        (parseInt(this.maxRangeInput.value) /
          parseInt(this.maxRangeInput.max)) *
        100
      }%`
    );
  }

  handleRangeMinChange(event) {
    event.stopPropagation();
    this.minPriceInput.value = event.target.value;
    this.minPriceInput.dispatchEvent(new Event("change", { bubbles: true }));
  }

  handleRangeMaxChange(event) {
    event.stopPropagation();
    this.maxPriceInput.value = event.target.value;
    this.maxPriceInput.dispatchEvent(new Event("change", { bubbles: true }));
  }

  handleRangeMinInput(event) {
    event.target.value = Math.min(
      parseInt(event.target.value),
      parseInt(this.maxPriceInput.value || event.target.max) - 1
    );
    event.target.parentElement.style.setProperty(
      "--range-min",
      `${(parseInt(event.target.value) / parseInt(event.target.max)) * 100}%`
    );
    this.minPriceInput.value = event.target.value;
  }

  handleRangeMaxInput(event) {
    event.target.value = Math.max(
      parseInt(event.target.value),
      parseInt(this.minPriceInput.value || event.target.min) + 1
    );
    event.target.parentElement.style.setProperty(
      "--range-max",
      `${(parseInt(event.target.value) / parseInt(event.target.max)) * 100}%`
    );
    this.maxPriceInput.value = event.target.value;
  }
}
customElements.define("price-range", PriceRange);

class FacetForm extends HTMLFormElement {
  constructor() {
    super();

    this.dirty = false;
    this.cachedMap = new Map();

    this.addEventListener("change", this.onFormChange);
    this.addEventListener("submit", this.onFormSubmit);
  }

  onFormChange(event) {
    this.dirty = true;
    this.lastChangeTarget = event.target;

    const syncResult = CedoraOptionsFilter.syncCategoryChildTrees(
      event.target,
      this
    );
    if (syncResult?.forceShopifySubmit && syncResult.proxyTarget) {
      this.lastChangeTarget = syncResult.proxyTarget;
    }

    this.dispatchEvent(new Event("submit", { cancelable: true }));
  }

  onFormSubmit(event) {
    event.preventDefault();
    if (!this.dirty) return;

    const isCustomOnlyChange =
      this.lastChangeTarget?.name === CEDORA_OPTION_PARAM ||
      this.lastChangeTarget?.name === CEDORA_PRODUCT_PARAM ||
      this.lastChangeTarget?.name === CEDORA_MATERIAL_PARAM ||
      this.lastChangeTarget?.name === CEDORA_COLOR_PARAM ||
      (this.lastChangeTarget?.name === CEDORA_SEATER_PARAM &&
        CedoraOptionsFilter.isDiningTableChecked(document)) ||
      (this.lastChangeTarget?.name === CEDORA_BED_SIZE_PARAM &&
        CedoraOptionsFilter.isBedFramesChecked(document));

    if (isCustomOnlyChange) {
      this.handleCedoraOptionsChange();
      this.lastChangeTarget = null;
      return;
    }

    const url = this.buildUrl().toString();
    this.renderSection(url, event);
    this.lastChangeTarget = null;
  }

  handleCedoraOptionsChange() {
    const url = this.buildUrl();

    if (this.hasAttribute("data-history")) {
      const clonedUrl = new URL(url.toString());
      clonedUrl.searchParams.delete("section_id");
      history.replaceState({}, "", clonedUrl.toString());
    }

    CedoraOptionsFilter.syncCheckboxesFromUrl(url.toString());
    CedoraOptionsFilter.apply();
    this.dirty = false;
    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  }

  buildUrl() {
    const searchParams = new URLSearchParams(new FormData(this));
    const url = new URL(this.action);

    url.search = "";
    searchParams.forEach((value, key) => {
      if (!CEDORA_CUSTOM_PARAMS.includes(key)) {
        url.searchParams.append(key, value);
      }
    });

    ["page", "filter.v.price.gte", "filter.v.price.lte"].forEach((item) => {
      if (url.searchParams.get(item) === "") {
        url.searchParams.delete(item);
      }
    });

    CedoraOptionsFilter.appendToUrl(url, this);
    url.searchParams.set("section_id", FoxTheme.utils.getSectionId(this));
    return url;
  }

  updateURLHash(url) {
    const clonedUrl = new URL(url);
    clonedUrl.searchParams.delete("section_id");
    history.replaceState({}, "", clonedUrl.toString());
    CedoraOptionsFilter.syncCheckboxesFromUrl(clonedUrl.toString());
  }

  beforeRenderSection() {
    const container = document.getElementById("ProductGridContainer");
    const loadings = document.querySelectorAll("[data-facet-loading]");
    const translateY = FoxTheme.config.motionReduced ? 0 : 50;

    FoxTheme.Motion.timeline([
      [container, { y: translateY, opacity: 0 }, { duration: 0 }],
    ]);

    setTimeout(() => {
      const target = document.querySelector(".collection");
      window.scrollTo({
        top: target.getBoundingClientRect().top + window.scrollY - 200,
        behavior: FoxTheme.config.motionReduced ? "auto" : "smooth",
      });
      if (loadings) {
        loadings.forEach((loading) => {
          loading.classList.add("btn--loading");
        });
      }
    }, 100);
  }

  afterRenderSection() {
    const container = document.getElementById("ProductGridContainer");
    const items = container.querySelectorAll(".product-card");
    const loadings = document.querySelectorAll("[data-facet-loading]");
    const translateY = FoxTheme.config.motionReduced ? 0 : 50;

    FoxTheme.Motion.timeline([
      [container, { y: [translateY, 0], opacity: [0, 1] }],
      [
        items,
        {
          y: [translateY, 0],
          opacity: [0, 1],
          visibility: ["hidden", "visible"],
        },
        {
          duration: 0.5,
          delay: FoxTheme.config.motionReduced
            ? 0
            : FoxTheme.Motion.stagger(0.1),
        },
      ],
    ]);

    if (loadings) {
      loadings.forEach((loading) => {
        loading.classList.remove("btn--loading");
      });
    }

    CedoraOptionsFilter.syncCheckboxesFromUrl();
    CedoraOptionsFilter.apply();
    document.dispatchEvent(new CustomEvent("collection:rerendered"));
  }

  renderSection(url, event) {
    this.cachedMap.has(url)
      ? this.renderSectionFromCache(url, event)
      : this.renderSectionFromFetch(url, event);

    if (this.hasAttribute("data-history")) this.updateURLHash(url);

    this.dirty = false;
    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  }

  renderSectionFromFetch(url, event) {
    this.beforeRenderSection();
    const start = performance.now();

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const execution = performance.now() - start;

        setTimeout(
          () => {
            this.renderFilters(responseText, event);
            this.renderFiltersActive(responseText);
            this.renderProductGridContainer(responseText);
            this.renderProductCount(responseText);
            this.renderSortBy(responseText);
            this.renderSortByMobile(responseText);

            FoxTheme.pubsub.publish(
              FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate,
              { responseText: responseText }
            );
            this.cachedMap.set(url, responseText);

            this.afterRenderSection();
          },
          execution > 250 ? 0 : 250
        );
      });
  }

  renderSectionFromCache(url, event) {
    this.beforeRenderSection();

    setTimeout(() => {
      const responseText = this.cachedMap.get(url);
      this.renderFilters(responseText, event);
      this.renderFiltersActive(responseText);
      this.renderProductGridContainer(responseText);
      this.renderProductCount(responseText);
      this.renderSortBy(responseText);
      this.renderSortByMobile(responseText);

      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate, {
        responseText: responseText,
      });

      this.afterRenderSection();
    }, 250);
  }

  renderFilters(responseText, event) {
    const parsedHTML = new DOMParser().parseFromString(
      responseText,
      "text/html"
    );
    const facetElements = parsedHTML.querySelectorAll(
      "#FacetFiltersContainer [data-filter], #MobileFacetFiltersContainer [data-filter]"
    );

    const matchesIndex = (element) => {
      const jsFilter = event
        ? event.target.closest("[data-filter]")
        : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetElements).filter(
      (element) => !matchesIndex(element)
    );

    facetsToRender.forEach((element) => {
      const filter = document.querySelector(
        `[data-filter][data-index="${element.dataset.index}"]`
      );
      if (filter !== null) {
        if (filter.tagName === "DETAILS") {
          filter.querySelector("summary + *").innerHTML =
            element.querySelector("summary + *").innerHTML;
        } else {
          filter.innerHTML = element.innerHTML;
        }
      }
    });
  }

  renderFiltersActive(responseText) {
    const id = "FacetFiltersActive";
    if (document.getElementById(id) === null) return;
    const parsedHTML = new DOMParser().parseFromString(
      responseText,
      "text/html"
    );

    document.getElementById(id).innerHTML =
      parsedHTML.getElementById(id) && parsedHTML.getElementById(id).innerHTML;
  }

  renderProductGridContainer(responseText) {
    const id = "ProductGridContainer";
    if (document.getElementById(id) === null) return;
    const parsedHTML = new DOMParser().parseFromString(
      responseText,
      "text/html"
    );

    document.getElementById(id).innerHTML =
      parsedHTML.getElementById(id) && parsedHTML.getElementById(id).innerHTML;

    const layoutSwitcher = document.querySelector("layout-switcher");
    if (layoutSwitcher)
      layoutSwitcher.onButtonClick(
        layoutSwitcher.querySelector(".btn--active")
      );


    /* [GLOBO - DISABLED]
    if(typeof Globo != 'undefined' && Globo?.Preorder)
      Globo?.Preorder?.initCollection();
    */
  }

  renderProductCount(responseText) {
    const id = "ProductCount";
    if (document.getElementById(id) === null) return;
    const parsedHTML = new DOMParser().parseFromString(
      responseText,
      "text/html"
    );

    document.getElementById(id).innerHTML =
      parsedHTML.getElementById(id) && parsedHTML.getElementById(id).innerHTML;
  }

  renderSortBy(responseText) {
    const id = "SortByContainer";
    if (document.getElementById(id) === null) return;
    const parsedHTML = new DOMParser().parseFromString(
      responseText,
      "text/html"
    );

    document.getElementById(id).innerHTML =
      parsedHTML.getElementById(id) && parsedHTML.getElementById(id).innerHTML;
  }

  renderSortByMobile(responseText) {
    const id = "SortByContainerMobile";
    if (document.getElementById(id) === null) return;
    const parsedHTML = new DOMParser().parseFromString(
      responseText,
      "text/html"
    );

    document.getElementById(id).innerHTML =
      parsedHTML.getElementById(id) && parsedHTML.getElementById(id).innerHTML;
  }
}
customElements.define("facet-form", FacetForm, { extends: "form" });

class FacetRemove extends HTMLAnchorElement {
  constructor() {
    super();
    this.addEventListener("click", this.onClick);
  }

  onClick(event) {
    const form =
      this.closest('form[is="facet-form"]') ||
      document.querySelector('form[is="facet-form"]');

    if (form) {
      event.preventDefault();

      const url = new URL(this.href, window.location.origin);

      if (
        !this.dataset.cedoraOptionActive &&
        !this.dataset.cedoraProductActive &&
        !this.classList.contains("facet-clear-all")
      ) {
        CedoraOptionsFilter.getSelectedOptions().forEach((option) => {
          url.searchParams.append(CEDORA_OPTION_PARAM, option);
        });
        CedoraOptionsFilter.getSelectedProducts().forEach((productFilter) => {
          url.searchParams.append(CEDORA_PRODUCT_PARAM, productFilter);
        });
        CedoraOptionsFilter.getSelectedMaterials().forEach((material) => {
          url.searchParams.append(CEDORA_MATERIAL_PARAM, material);
        });
        CedoraOptionsFilter.getSelectedColors().forEach((color) => {
          url.searchParams.append(CEDORA_COLOR_PARAM, color);
        });
        CedoraOptionsFilter.getSelectedSeaters().forEach((seater) => {
          url.searchParams.append(CEDORA_SEATER_PARAM, seater);
        });
        CedoraOptionsFilter.getSelectedBedSizes().forEach((bedSize) => {
          url.searchParams.append(CEDORA_BED_SIZE_PARAM, bedSize);
        });
      }

      url.searchParams.set("section_id", FoxTheme.utils.getSectionId(form));
      form.renderSection(url.toString(), event);

      document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
    }
  }
}
customElements.define("facet-remove", FacetRemove, { extends: "a" });

class FacetCount extends HTMLElement {
  constructor() {
    super();
  }

  facetUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.facetUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate,
      this.onFacetUpdate.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.facetUpdateUnsubscriber) {
      this.facetUpdateUnsubscriber();
    }
  }

  get itemCount() {
    return parseInt(this.innerText.replace(/\D/g, ""));
  }

  onFacetUpdate(event) {
    const parsedHTML = new DOMParser().parseFromString(
      event.responseText,
      "text/html"
    );
    const facetCount = parsedHTML.querySelector("facet-count");
    this.innerText = facetCount && facetCount.innerHTML;
    this.hidden = this.itemCount === 0;
  }
}
customElements.define("facet-count", FacetCount);

class FacetToggler extends HTMLButtonElement {
  constructor() {
    super();
    this.onClickHandler = this.onClick.bind(this);
  }

  connectedCallback() {
    this.facetEl = document.getElementById("FacetFiltersContainer");
    this.addEventListener("click", this.onClickHandler);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.onClickHandler);
  }

  onClick(evt) {
    evt.preventDefault();

    if (this.facetEl.classList.contains("xl:block")) {
      this.facetEl.classList.remove("xl:block");
    } else {
      this.facetEl.classList.add("xl:block");
    }
  }
}
customElements.define("facet-toggler", FacetToggler, { extends: "button" });

class LoadMoreButton extends HTMLButtonElement {
  constructor() {
    super();
    this.onClickHandler = this.onClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener("click", this.onClickHandler);

    if (this.getAttribute("type") == "infinite") {
      FoxTheme.Motion.inView(this, this.onClickHandler, {
        margin: "200px 0px 200px 0px",
      });
    }
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.onClickHandler);
  }

  onClick() {
    if (this.classList.contains("btn--loading")) return;
    this.loadingState();

    const url = this.setUrl().toString();

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        this.renderPagination(responseText);
        this.renderProductGridContainer(responseText);
      });

     document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  }

  renderPagination(responseText) {
    const productGridContainer = document.getElementById(
      "ProductGridContainer"
    );
    if (productGridContainer === null) return;

    const parsedHTML = new DOMParser().parseFromString(
      responseText,
      "text/html"
    );
    const pagination = productGridContainer.querySelector(".pagination");
    const source = parsedHTML.querySelector(".pagination");

    if (source) {
      pagination.innerHTML = source.innerHTML;
    } else {
      pagination.remove();
    }
  }

  renderProductGridContainer(responseText) {
    const productGridContainer = document.getElementById(
      "ProductGridContainer"
    );
    if (productGridContainer === null) return;

    const parsedHTML = new DOMParser().parseFromString(
      responseText,
      "text/html"
    );
    const productList = productGridContainer.querySelector(".products-list");
    const gridList = productGridContainer.querySelector("grid-list");
    const source = parsedHTML.querySelector(".products-list");

    if (source && productList) {
      // Get all cards from the response, including both product and image cards
      const allCards = source.querySelectorAll(
        ".card, .image-column, .product-column"
      );

      // Append all cards to maintain the correct order
      allCards.forEach((item) => {
        productList.appendChild(item);
      });

      // Reload grid if needed
      gridList && gridList.reload();

      // Remove loading state
      this.classList.remove("pointer-events-none");
      this.classList.remove("btn--loading");

      CedoraOptionsFilter.apply();

      // Dispatch event for other components to know products were loaded
      document.dispatchEvent(new CustomEvent("products:loaded"));
    }
  }

  setUrl() {
    let actionUrl = this.dataset.action || this.getAttribute("action");
    // Check if the URL already has the domain in it
    if (actionUrl.includes("//")) {
      // Already a full URL, use as is
      const url = new URL(actionUrl);
      url.searchParams.set("section_id", FoxTheme.utils.getSectionId(this));
      return url;
    } else {
      // Relative URL, prepend with window.location.origin
      const url = new URL(actionUrl, window.location.origin);
      url.searchParams.set("section_id", FoxTheme.utils.getSectionId(this));
      return url;
    }
  }

  loadingState() {
    this.classList.add("pointer-events-none");
    this.classList.add("btn--loading");
  }
}
customElements.define("load-more-button", LoadMoreButton, {
  extends: "button",
});

class LayoutSwitcher extends HTMLElement {
  constructor() {
    super();
    this.cookieName = "hypertheme:collection-layout";

    this.initLayoutMode();
    this.buttons.forEach((button) => {
      button.addEventListener("click", this.onButtonClick.bind(this));
    });

    document.addEventListener("matchMobile", () => this.initLayoutMode());
    document.addEventListener("unmatchMobile", () => this.initLayoutMode());
  }

  get buttons() {
    return this.querySelectorAll("button");
  }

  getStorageKey() {
    const viewport = FoxTheme.config.mqlMobile ? "mobile" : "desktop";
    return `${this.cookieName}:${viewport}`;
  }

  getDefaultLayoutMode() {
    return FoxTheme.config.mqlMobile ? "list" : "grid";
  }

  /**
   * @param {event|element} evt
   */
  onButtonClick(evt) {
    const target = evt.currentTarget ? evt.currentTarget : evt;
    this.changeLayout(target, target.dataset.layoutMode);
  }

  initLayoutMode() {
    let layoutMode = this.getDefaultLayoutMode();

    if (FoxTheme.config.hasLocalStorage) {
      const storedLayoutMode = window.localStorage.getItem(this.getStorageKey());
      if (storedLayoutMode !== null) {
        layoutMode = storedLayoutMode;
      }
    }

    const target = this.querySelector(
      `button[data-layout-mode="${layoutMode}"]`
    );
    if (target) {
      this.changeLayout(target, layoutMode);
    }
  }

  changeLayout(target, layoutMode) {
    const productGrid = document.getElementById("ProductsList");
    if (!productGrid) return;

    productGrid.dataset.layout = layoutMode;

    if (productGrid.dataset.gridClass) {
      const productCards = productGrid.querySelectorAll(".product-card");
      productCards &&
        productCards.forEach((card) => {
          if ("grid" === layoutMode) {
            card.classList.add(productGrid.dataset.gridClass);
          } else {
            card.classList.remove(productGrid.dataset.gridClass);
          }
        });
    }

    this.buttons.forEach((button) => {
      button.classList.remove("btn--active");
    });
    target.classList.add("btn--active");

    if (FoxTheme.config.hasLocalStorage) {
      window.localStorage.setItem(this.getStorageKey(), layoutMode);
    }
  }
}
customElements.define("layout-switcher", LayoutSwitcher);

document.addEventListener("DOMContentLoaded", () => {
  CedoraOptionsFilter.init();
  CedoraOptionsFilter.syncCheckboxesFromUrl();
  CedoraOptionsFilter.apply();
});

document.addEventListener("products:loaded", () => {
  CedoraOptionsFilter.apply();
});
